module.exports = __webpack_public_path__ + "static/media/e2.70dad7dc.jpg";